export default "__VITE_ASSET__D1V2z4Xo__"